module.exports = __webpack_public_path__ + "static/media/home.fe5069c3.png";